import React, { Component } from 'react';
import Draggable from 'react-draggable';
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { TabPane, Tab } from 'semantic-ui-react';
import '../map.scss';
import { Utils } from '../../../services/utils/utils';
import OutputPopupContent from './OutputPopupContent';
import WeatherLayerPopupContent from './WeatherLayerPopupContent';

// Map of Data Types and their units key for translation
const dataTypeUnits = {
    "CONCENTRATION": "kg_m3",
    "INDOOR_CONCENTRATION": "kg_m3",
    "INDOOR_DOSAGE": "kgs_m3",
    "DOSAGE": "kgs_m3",
    "LCT50": false,
    "ICT50": false,
    "ECT50": false,
    "AEGLS": false,
    "DEPOSITION": "kg_m2",
    "BLAST": "psi",
    "ATP-45": false,
    "CED_WORKER_SLOW_LUNG_CLASS": "mSv",
    "CED_WORKER_MED_LUNG_CLASS": "mSv",
    "CED_WORKER_FAST_LUNG_CLASS": "mSv",
    "CED_WORKER_VAPOUR": "mSv",
    "CED_WORKER_INERT": "mSv",
    "CED_ADULT_SLOW_LUNG_CLASS": "mSv",
    "CED_ADULT_MED_LUNG_CLASS": "mSv",
    "CED_ADULT_FAST_LUNG_CLASS": "mSv",
    "CED_ADULT_INERT": "mSv",
    "CED_15_YEAR_OLD_SLOW_LUNG_CLASS": "mSv",
    "CED_15_YEAR_OLD_MED_LUNG_CLASS": "mSv",
    "CED_15_YEAR_OLD_FAST_LUNG_CLASS": "mSv",
    "CED_15_YEAR_OLD_INERT": "mSv",
    "CED_10_YEAR_OLD_SLOW_LUNG_CLASS": "mSv",
    "CED_10_YEAR_OLD_MED_LUNG_CLASS": "mSv",
    "CED_10_YEAR_OLD_FAST_LUNG_CLASS": "mSv",
    "CED_10_YEAR_OLD_INERT": "mSv",
    "CED_5_YEAR_OLD_SLOW_LUNG_CLASS": "mSv",
    "CED_5_YEAR_OLD_MED_LUNG_CLASS": "mSv",
    "CED_5_YEAR_OLD_FAST_LUNG_CLASS": "mSv",
    "CED_5_YEAR_OLD_INERT": "mSv",
    "CED_1_YEAR_OLD_SLOW_LUNG_CLASS": "mSv",
    "CED_1_YEAR_OLD_MED_LUNG_CLASS": "mSv",
    "CED_1_YEAR_OLD_FAST_LUNG_CLASS": "mSv",
    "CED_1_YEAR_OLD_INERT": "mSv",
    "CED_INFANT_SLOW_LUNG_CLASS": "mSv",
    "CED_INFANT_MED_LUNG_CLASS": "mSv",
    "CED_INFANT_FAST_LUNG_CLASS": "mSv",
    "CED_INFANT_INERT": "mSv"
}

class OutputPopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            position: props.position,
            width: window.innerWidth,
            height: window.innerHeight,
            queryParams: props.queryParams,
        }

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        window.addEventListener('resize', this.updateDimensions);
    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    shouldComponentUpdate(prevProps, prevState) {
        return prevState.width !== this.state.width ||
            prevState.height !== this.state.height
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.props.hidePopup();
        }
    }


    getOutputView = () => {
        const { t } = this.props;

        const panes = [];
        
        for(const queryParam of this.state.queryParams) {
            const dataTypes = this.props.resultsState.dataTypes[queryParam.simulationId];
            let dataTypeName = queryParam.dataTypeId;
            if (dataTypes) {
                const dataType = dataTypes.find(dt => dt.id === queryParam.dataTypeId)
                if(dataType) {
                    dataTypeName = t("dataTypes." + dataType.name);
                }
              }
            panes.push({ menuItem: dataTypeName, 
                render: () => {
                    // For weather layer render custom weather popup
                    if(queryParam.dataTypeId === 12) {
                        return <TabPane><WeatherLayerPopupContent key={queryParam.dataTypeId} queryParams={queryParam}/></TabPane> 
                    }
                    return <TabPane><OutputPopupContent key={queryParam.dataTypeId} queryParams={queryParam}/></TabPane> 
                }
            })
        }
        return <Tab panes={panes} />
    }

    render() {
        const { t } = this.props;
        let currTime = this.props.currentTime;
        // Create a Draggable component bounds that will not allow to drag the popup
        // outside the visible window, with 200 pixels of the popup always visble
        return (
            <Draggable
                bounds={{
                    left: -this.state.position.x - 200,
                    top: -this.state.position.y - 200,
                    right: this.state.width - this.state.position.x - 200,
                    bottom: this.state.height - this.state.position.y - 200,
                }}>
                <div className="leaflet-popup-content-wrapper ua-popup output-popup" ref={this.wrapperRef}
                    style={{
                        left: this.state.position.x + 'px',
                        top: this.state.position.y + 'px'
                    }}>
                    {this.getOutputView()}
                </div>
            </Draggable>
        )
    }

}

const mapStateToProps = (store) => {
    return {
        simulationState: store.simulationState,
        scenarioState: store.scenarioState,
        currentTime: store.mapState.currentTime,
        position: store.mapState.position,
        resultsState: store.resultsState,
    }
}
export default compose(withTranslation(), connect(mapStateToProps))(OutputPopup);